module.exports = __webpack_public_path__ + "img/arrows-alt-h-solid.ba9abe07.svg";